import {Dialog, DialogActions, DialogContent, Typography } from "@mui/material";
import ErrorIcon from "@mui/icons-material/Error";

const ErrorTokenDialog = (props) => {

    const {openErrorDialog, handleClose, series} = props;

    

    return (
        <Dialog open={openErrorDialog} maxWidth={"sm"} fullWidth={"sm"} PaperProps={{style: {borderRadius: 5, margin: "auto"}}}>
            <DialogContent className="btn-error" sx={{p: 2, textAlign: "center", borderRadius: 0}}>
                <ErrorIcon sx={{color: "#fff", height: 50, width: 50}} />
            </DialogContent>

            <DialogContent sx={{textAlign: "center", mt: 2, mb: 0}}>
                <Typography sx={{color: "gray", fontSize: 16, fontFamily: 'GucciSans'}}>
                   Token not found in {series.charAt(0).toUpperCase() + series.slice(1)} series.
                </Typography>
            </DialogContent>

            <DialogActions sx={{justifyContent: "center", mb: 2}}>
                <button className="btn-error" onClick={handleClose} style={{fontFamily: 'GucciSans'}} >
                   Close
                </button>
            </DialogActions>
        </Dialog>
    )
}

export default ErrorTokenDialog